import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import ClientsCarousel from "./ClientsCarousel";
import globe from "../../../assets/globe.jpeg";
// import ClientsCarousel from "./ClientsCarousel";

const stats = [
    { label: "Customers Globally", value: 2000 },
    { label: "Products", value: 200 },
    { label: "Years of Experience", value: 25 }
];

const Counter = ({ endValue, inView }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (inView) {
            let start = 0;
            const duration = 2000; // Animation duration in ms
            const stepTime = 50; // Update interval in ms
            const step = endValue / (duration / stepTime);

            const interval = setInterval(() => {
                start += step;
                if (start >= endValue) {
                    setCount(endValue);
                    clearInterval(interval);
                } else {
                    setCount(Math.floor(start));
                }
            }, stepTime);

            return () => clearInterval(interval);
        }
    }, [inView, endValue]);

    return (
        <motion.span className="text-6xl font-bold text-green-800">
            {count}+
        </motion.span>
    );
};

const ClientsCarouselEmbla = () => {
    const { ref: titleRef, inView: titleInView } = useInView({ triggerOnce: false, threshold: 0.2 });

    return (
        <div className="bg-white text-black py-10 text-left">
            {/* Section Heading */}
            <motion.h2
                ref={titleRef}
                className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6"
                initial={{ opacity: 0, y: 30 }}
                animate={titleInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <span className="text-green-800">Pleasure to work with. </span>
                <span className="text-gray-600 font-semibold">Endorsed by top companies globally.</span>
            </motion.h2>

            {/* Two-Section Container */}
            <TwoSection />

            <div className="w-full flex flex-col items-center mt-20 hidden md:flex">
    <ClientsCarousel />
</div>

        </div>
    );
};

const TwoSection = () => {
    const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.5 });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full flex flex-col md:flex-row h-[500px] mt-12 mb-20"
        >
            {/* Left Section - Stats Cards */}
            <div className="w-full md:w-1/2 flex flex-col justify-center gap-6">
                {/* Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
                    {stats.slice(0, 2).map((stat, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={inView ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.2 }}
                            className="flex-1 bg-white rounded-2xl p-6 flex flex-col items-start text-start"
                        >
                            <Counter endValue={stat.value} inView={inView} />
                            <h2 className="text-lg font-bold text-green-800">{stat.label}</h2>
                            <p className="text-sm text-gray-700 mt-2">
                                {index === 0
                                    ? "Trusted worldwide for high-quality environmental monitoring solutions."
                                    : "A diverse range of in-house manufactured and imported products for various industries."}
                            </p>
                        </motion.div>
                    ))}
                </div>

                {/* Single Large Card */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={inView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                    className="w-full bg-white rounded-2xl p-6 flex flex-col items-start text-start"
                >
                    <Counter endValue={stats[2].value} inView={inView} />
                    <h2 className="text-lg font-bold text-green-800">{stats[2].label}</h2>
                    <p className="text-sm text-gray-700 mt-2">
                        Decades of expertise in delivering cutting-edge environmental monitoring solutions.
                    </p>
                </motion.div>
            </div>

            {/* Right Section - Background Image */}
            <div
                className="w-full md:w-1/2 h-full"
                style={{
                    backgroundImage: `url(${globe})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                }}
            ></div>
        </motion.div>
    );
};

export default ClientsCarouselEmbla;
